import React from 'react';
import ScrollToTop from 'gatsby-core-theme/src/components/atoms/scroll-to-top';

export default (props) => <ScrollToTop {...props} hideOnScrollDown={true} />;
